


















import { computed, defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'ButtonAction',

  inheritAttrs: false,

  props: {
    iconName: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    }
  },

  setup(props) {
    const itemsCountLabel = computed(() => (props.items.length ? ` (${props.items.length})` : undefined))
    return {
      itemsCountLabel
    }
  }
})
